<!-- Entry Heading -->
<div class="dt-entry__heading">
  <h3 *ngIf="heading" class="dt-entry__title" [innerHTML]="heading"></h3>
</div>
<!-- /entry heading -->

<ng-content></ng-content>
